var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0 -7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12853",
    "data-name": "Group 12853",
    transform: "translate(0 7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12762",
    "data-name": "Path 12762",
    d: "M24,15.5s-4.5-8-12-8-12,8-12,8,4.5,8,12,8S24,15.5,24,15.5Zm-22.24,0a19.23,19.23,0,0,1,2.49-2.972A11.316,11.316,0,0,1,12,8.955a11.326,11.326,0,0,1,7.752,3.574,19.23,19.23,0,0,1,2.49,2.972c-.087.127-.183.266-.293.419a19.327,19.327,0,0,1-2.2,2.553A11.329,11.329,0,0,1,12,22.045a11.326,11.326,0,0,1-7.752-3.574A19.232,19.232,0,0,1,1.758,15.5Z",
    transform: "translate(0 -7.5)",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12763",
    "data-name": "Path 12763",
    d: "M18.75,14.955a3.638,3.638,0,1,0,3.75,3.636,3.694,3.694,0,0,0-3.75-3.636ZM13.5,18.591a5.252,5.252,0,1,1,5.25,5.091A5.172,5.172,0,0,1,13.5,18.591Z",
    transform: "translate(-6.75 -10.591)",
    fill: "#600097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.37dbd97a542de0f468d5b02e09466b4d.svg";
export { ForwardRef as ReactComponent };